module.exports = __webpack_public_path__ + "static/media/bubble_sound.fb8bba87.wav";